<template>
  <span>
    <AppSelectBox
      label="شرط"
      :items="def"
      :item-text="$t"
      item-value="condition"
      v-bind="$attrs"
      v-on="$listeners"
    ></AppSelectBox>
  </span>
</template>

<script>
import AppSelectBox from "@/components/library/inputFields/AppSelectBox";

export default {
  name: "AbrAdvancedSearchCondition",
  components: { AppSelectBox },
  props: ["def"]
};
</script>

<style>
.v-select__selection.v-select__selection--comma {
  font-size: 14px!important;
}
</style>
